/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbMobileRefineMenuFilterDimensions_user$ref = any;
type SbMobileRefineMenuFilterPrice_user$ref = any;
type SbRespRefineMenuFilterDimensions_user$ref = any;
type SbRespRefineMenuFilterPrice_user$ref = any;
type TradeOnboardingCoachmarkConditionalLoader_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilters_user$ref: FragmentReference;
export type SbSharedRefineMenuFilters_user = {|
  +$fragmentRefs: SbRespRefineMenuFilterPrice_user$ref & SbRespRefineMenuFilterDimensions_user$ref & SbMobileRefineMenuFilterPrice_user$ref & SbMobileRefineMenuFilterDimensions_user$ref & TradeOnboardingCoachmarkConditionalLoader_user$ref,
  +$refType: SbSharedRefineMenuFilters_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilters_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterPrice_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterPrice_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDimensions_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeOnboardingCoachmarkConditionalLoader_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6342fa9454da3e7b7a876ada995037a4';
module.exports = node;
